// extracted by mini-css-extract-plugin
module.exports = {"container":"aS","recos":"bS","productCardOverride":"cS"};